import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { format, startOfDay } from 'date-fns';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { startWith, switchMap, tap } from 'rxjs/operators';
import { CarrierCommitmentsService, Region } from '../carrier-commitments.service';
import { FFDriverShiftPredictionBlocksEntity, FFShifts, FfShiftService } from '../ff-shift.service';

@Component({
  selector: 'lohi-shift-tool',
  templateUrl: './shift-tool.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShiftToolComponent implements OnInit {
  @HostBinding('class.overflow-y-scroll') public scroll = true;

  public regionControl = new FormControl(null);
  public startControl = new FormControl(startOfDay(new Date()));
  public data$: Observable<FFShifts>;
  public regions$: Observable<Region[]>;
  public date = new Date();

  public group$$ = new BehaviorSubject<FFDriverShiftPredictionBlocksEntity>(null);

  constructor(private carrierComService: CarrierCommitmentsService, private shiftDataService: FfShiftService) {}

  public ngOnInit(): void {
    this.regions$ = this.carrierComService.regions$;
    this.data$ = combineLatest([
      this.regionControl.valueChanges,
      this.startControl.valueChanges.pipe(startWith(new Date())),
    ]).pipe(
      tap(() => this.group$$.next(null)),
      switchMap(([region, date]) => {
        return this.shiftDataService.getShiftData(region, format(date, 'yyyy-MM-dd'));
      }),
    );
  }

  public setGroup(drivers: FFDriverShiftPredictionBlocksEntity) {
    this.group$$.next(drivers);
  }
}
